import { Pager } from '@components/core-ui/Pagination/components/pager';

type TProps = {
  totalCount: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

export const SectionPagination = ({ totalCount, page, pageSize, onPageChange, onPageSizeChange }: TProps) => {
  const totalPages = Math.max(1, Math.ceil((totalCount || 1) / pageSize));
  const start = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(totalCount, page * pageSize);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-xs text-[var(--color-text-muted)]">
      <div className="flex items-center gap-2">
        <span>Rows per page</span>
        <select
          value={pageSize}
          onChange={(event) => {
            onPageSizeChange(Number(event.target.value));
            onPageChange(1);
          }}
          className="border border-[var(--color-divider)] rounded-md px-2 py-1 bg-[var(--color-surface)] text-[var(--color-text)]"
        >
          {[10, 25, 50, 100].map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        <span>{totalCount ? `Showing ${start}-${end} of ${totalCount}` : 'No rows to display'}</span>
      </div>

      <div className="flex items-center gap-3">
        <span>
          Page {Math.min(page, totalPages)} of {totalPages}
        </span>
        <Pager
          currentPage={Math.min(page, totalPages)}
          pagesCount={totalPages}
          onChange={(nextPage) => onPageChange(nextPage)}
          className="pager"
        />
      </div>
    </div>
  );
};
